import { completeChapter, completed as completedChapters } from "./chapters.js";
import { scheduleScript } from "./script/index.js";
import { latLngDist } from "./utils.js";
import { intro2 } from "./script/intro.js";
import { disableCruiseControl } from "./cruise-control.js";

const CHECKPOINT_DISTANCE_THRESHOLD = 30;

export const checkpoints = [
  {
    lat: -20.448960415574838,
    lng: -69.50836064903369,
    passed: completedChapters.size > 0,
    async callback(context) {
      return scheduleScript(intro2, context);
    },
  },
];

window.checkpoints = checkpoints;

export const checkForCheckpoints = (G) => () => {
  const position = G.map.getPosition();

  for (const checkpoint of checkpoints) {
    if (checkpoint.passed) {
      continue;
    }

    const distanceFromCheckpoint = latLngDist(
      position,
      new google.maps.LatLng(checkpoint.lat, checkpoint.lng),
    );

    if (distanceFromCheckpoint < CHECKPOINT_DISTANCE_THRESHOLD) {
      console.info("[checkpoints]", "triggering", checkpoint);
      checkpoint.passed = true;

      disableCruiseControl(G);

      checkpoint.callback(G).then(() => {
        if (checkpoint.chapter) {
          completeChapter(checkpoint.chapter);
        }
      });
    }
  }
};

export const goToNextCheckpoint = (G) => {
  const nextUnpassed = checkpoints.find((c) => !c.passed);
  if (!nextUnpassed) return;

  const pov = G.map.getPov();
  G.map.setPosition({ lat: nextUnpassed.lat, lng: nextUnpassed.lng });
  G.map.setPov(pov);
};
